module.exports = __webpack_public_path__ + "img/194.7276b38d.jpg";